import axios from "@/plugins/axios";
const local = false;
/**
 * Conecta con el socket para refrescar .
 *
 */
export function refreshStrategyUsers(data) {
  const url = local
    ? "http://localhost:8081/strategies/refresh-users"
    : `${import.meta.env.VITE_SOCKET}strategies/refresh-users`;

  return axios.post(url, data);
}
